'use client'

import { useEffect } from 'react'

import { jwtRolesToUserRole } from '@/lib/analytics/dataLayer'
import { pushUserIdentityToDataLayer } from '@/lib/analytics/userIdentity'
import { installProductAnalytics, setUserId } from '@/lib/productAnalytics'
import { useAuthStore } from '@/stores/authStore'
import { getSessionTokenPayload } from '@/utils/auth'

/**
 * Keeps the dataLayer user variables in sync with the authenticated user so
 * GTM can populate the GA4 User-ID field for every session, not only right after
 * a fresh login/signup event (OCE #8). Renders nothing.
 *
 * Rendered before DeferredAnalyticsScripts: its effect has to run first, so the
 * identity is in the dataLayer ahead of gtm.js.
 */
const AnalyticsIdentity = () => {
  const isAuthenticated = useAuthStore(s => s.isAuthenticated)
  const storeUserId = useAuthStore(s => s.user?.user?.id ?? null)

  useEffect(() => installProductAnalytics(), [])

  useEffect(() => {
    // The token has the id before /me answers, so the landing page_view is
    // not sent anonymous.
    const payload = isAuthenticated ? getSessionTokenPayload() : null
    const tokenUserId =
      typeof payload?.user_id === 'string' ? payload.user_id : null
    const userId = isAuthenticated ? tokenUserId ?? storeUserId : null
    pushUserIdentityToDataLayer(
      userId
        ? { userId, role: jwtRolesToUserRole(payload?.roles, payload) }
        : null
    )
    setUserId(userId)
  }, [isAuthenticated, storeUserId])

  return null
}

export default AnalyticsIdentity
